import { TESTIMONIALS } from "~/utils/constants";
import { IcoStar } from "~/icons";
import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";

import "swiper/css";

const Testimonials = () => {
  return (
    <section className="max-md:py-12 py-[100px]" id="testimonials">
      <div className="container">
        <h2 className="max-lg:text-4xl max-lg:leading-[49px] text-center text-white text-5xl font-extrabold leading-[60px]">
          Testimonials
        </h2>
        <p className="max-lg:text-xl max-lg:leading-7 text-center text-white text-2xl font-light font tracking-tight mt-4">
          300K+ HAPPY LISTENERS
        </p>
        <div className="mt-8">
          <Swiper
            className="max-md:pb-8 authors__slider"
            slidesPerView={4}
            spaceBetween={18}
            loop
            modules={[Autoplay]}
            autoplay={{
              delay: 2500,
              disableOnInteraction: false,
            }}
            speed={900}
            breakpoints={{
              320: {
                slidesPerView: 1,
              },
              769: {
                slidesPerView: 2,
              },
              992: {
                slidesPerView: 3,
              },
              1201: {
                slidesPerView: 4,
              },
            }}
          >
            {TESTIMONIALS.map((testimonial, index) => (
              <SwiperSlide
                key={"testimonial_" + index}
                className="bg-[rgba(255,_255,_255,_0.08)] p-4 rounded-xl h-full testimonials__slider"
              >
                <img
                  className="mx-auto w-[60px]"
                  src={testimonial.image}
                  alt={testimonial.author}
                />
                <div className="flex justify-center my-3">
                  {Array.from({ length: testimonial.stars }, (_, index) => (
                    <IcoStar key={`star_${index}`} className="mr-0.5" />
                  ))}
                </div>
                <div className="px-4 text-white italic text-center">
                  {testimonial.text}
                </div>
                <div className="text-center mt-3 text-sm leading-5 text-white opacity-70">
                  {testimonial.author}
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </section>
  );
};

Testimonials.displayName = "Testimonials";
export default Testimonials;
